import Immutable from 'seamless-immutable';
import { ACTIONS } from './actions';

export const initialState = (input = {}) =>
  Immutable.from({
    // Modal
    showConfirmationModal: false,
    // Company
    isSelectBoxOpen: false,
    companySearchInput: '',
    selectedCompany: null,
    isNewCompany: false,
    companyCreateError: false,
    // Roles
    roleSearchInput: '',
    selectedRole: null,
    // Emails
    emails: [],
    numberOfInvalidEmails: 0,
    numberOfDuplicatedEmails: 0,
    emailSearchInput: '',

    areUsersInvited: false,
    isSaving: false,
    ...input,
  });

export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_COMPANY:
      return state.merge({
        selectedCompany: action.payload,
        isNewCompany: false,
        companySearchInput: '',
      });
    case ACTIONS.SET_IS_NEW_COMPANY:
      return state.set('isNewCompany', true);
    case ACTIONS.OPEN_COMPANY_SELECT_BOX:
      return state.set('isSelectBoxOpen', action.payload);
    case ACTIONS.SET_COMPANY_SEARCH_INPUT:
      return state.set('companySearchInput', action.payload);
    case ACTIONS.SET_SHOW_COMPANY_CREATE_ERROR:
      return state.set('companyCreateError', action.payload);
    case ACTIONS.SET_ROLE:
      return state.merge({
        selectedRole: action.payload,
        roleSearchInput: '',
      });
    case ACTIONS.SET_ROLE_SEARCH_INPUT:
      return state.set('roleSearchInput', action.payload);
    case ACTIONS.SHOW_MAIN_MODAL:
      return state.set('showMainModal', action.payload);
    case ACTIONS.SHOW_CONFIRMATION_MODAL:
      return state.set('showConfirmationModal', action.payload);
    case ACTIONS.RESET_INFORMATION:
      return state.merge({
        companySearchInput: '',
        selectedCompany: null,
        isNewCompany: false,
        roleSearchInput: '',
        selectedRole: null,
        emails: [],
        numberOfInvalidEmails: 0,
        numberOfDuplicatedEmails: 0,
        emailSearchInput: '',
      });
    case ACTIONS.SET_EMAIL_SEARCH_INPUT:
      return state.set('emailSearchInput', action.payload);
    case ACTIONS.SET_EMAILS:
      return state.merge({
        emails: action.payload.emails,
        numberOfInvalidEmails: action.payload.numberOfInvalidEmails,
        numberOfDuplicatedEmails: action.payload.numberOfDuplicatedEmails,
      });
    case ACTIONS.SET_IS_SAVING:
      return state.set('isSaving', action.payload);
    case ACTIONS.SET_ARE_USERS_INVITED:
      return state.set('areUsersInvited', action.payload);
    default:
      return state;
  }
};
